import * as Sentry from '@sentry/nextjs';

import type { HttpConfig } from '../api/http';

interface TrackApiErrorPayload {
  status: number;
  endpoint: string;
  method: string;
  message: string;
}

const ignorePatterns = [
  /неверный смс.?код/i,
  /booking not found/i,
  /timeslot is not available/i,
  /истекло время для подтверждения/i,
  /неверный ИИН/i,
  /поле code должно быть целым числом/i,
  /повторно отправить код подтверждения/i,
];

export function trackApiError(config: HttpConfig) {
  return (data: TrackApiErrorPayload) => {
    const shouldIgnore = ignorePatterns.some(pattern => pattern.test(data.message));

    if (!shouldIgnore) {
      Sentry.captureMessage(data.message, {
        level: 'error',
        tags: {
          custom: true,
        },
        extra: {
          ...data,
          config,
        },
      });
    }
  };
}
